export const Constants = {
  IS_DESKTOP: { minWidth: 1024 },
  IS_MOBILE: { minWidth: 375, maxWidth: 767 },
  IS_IPAD_PRO: { minWidth: 834, maxWidth: 1023 },
};

export default Constants;
